<template>
  <div class="main-description-header" ref="pack">
    <div
      class="main-description-header-packs"
      :class="{ 'less-packs': !morePacks }"
      @click="openMoreInfo"
    >
      <div
        v-for="(pack, index) in getPackages"
        :key="index"
        v-show="pack.name"
        class="main-description-pack"
      >
        <svg
          v-if="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 17 13"
          width="17px"
          height="13px"
        >
          <path
            fill="#6D9E11"
            fill-rule="nonzero"
            d="M5.281818 9.9977275L1.320455 6.0363638 0 7.3568184l5.281818 5.2818183L16.6 1.3204546 15.279546 0z"
          />
        </svg>
        <span>{{
          pack.name.charAt(0) == "-" ? pack.name.slice(1) : pack.name
        }}</span>
      </div>
    </div>
    <div class="dealer-car-packs__btn-wrapper" v-if="showMore">
      <div class="btn-more" @click.prevent="showMorePacks($event)">
        {{ !morePacks ? "+ Sýna allan búnað" : "- Fela allan búnað" }}
      </div>
    </div>
  </div>
</template>


<script>
import scroll from "@/helpers/scroll";
export default {
  props: {
    isOld: {
      type: Boolean,
      default: false
    },
    carPacks: {
      type: [Object, Array],
    },
    icon: {
      type: Boolean,
      default: true,
    },
    more: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    morePacks: true,
  }),
  methods: {
    showMorePacks() {
      if(this.$store.state.isApp && this.morePacks) {
        this.morePacks = !this.morePacks;
        let scrollTo = this.$refs.pack.offsetTop - 120;

        if(this.$device.ios()){
          scrollTo = this.$refs.pack.offsetTop - 70;
        }

        scroll.to(scrollTo);
      } else {
        let targetPositionTop =  window.pageYOffset + this.$refs.pack.getBoundingClientRect().top;
        if (this.morePacks && targetPositionTop - 120 < window.pageYOffset) {
          scroll.to(targetPositionTop - 120 );
        }
         this.morePacks = !this.morePacks;
      }
    },
    openMoreInfo() {
      if (!this.morePacks) {
        this.morePacks = true;
      }
    },
  },
  computed: {
    showMore() {
      if(this.isOld){
        return  false;
      }
      return this.$device.mobile() ? (this.carPacks.length > 5) : (this.carPacks.length > 15);
    },
    getPackages(){
      return this.carPacks.sort((a,b) => a.name.localeCompare(b.name));
    }
  },
  watch: {
    more: {
      immediate: true,
      handler() {
        if (this.carPacks.length > 15 || (this.$device.mobile() && this.carPacks.length > 5)) {
          this.morePacks = !this.more;
        }
      },
    },
  },
};
</script>
